import type { Components } from '@mui/material/styles';

export default function MUIAvatarGroup(): Components['MuiAvatarGroup'] {
  return {
    styleOverrides: {
      root: {
        display: 'inline-flex',
      },
      avatar: {
        boxShadow: '0 0 0 0 transparent',
      },
    },
  };
}
